import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom, map } from 'rxjs/operators';

import * as fromStore from '../store';
import * as fromRoot from '../../store';
import { combineLatest, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContentPageDetailGuard {
  private store = inject<Store<fromStore.ContentState>>(Store);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.checkStore(route).pipe(
      switchMap(a => of(a)),
      catchError(() => of(false))
    );
  }

  checkStore(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return combineLatest([
      this.store.select(fromRoot.getRouterState),
      this.store.select(fromStore.getSelectedContentPage),
      this.store.select(fromStore.getSelectedContentPageLoading),
      this.store.select(fromStore.getSelectedContentPageLoaded),
      this.store.select(fromStore.getContentPagesError),
    ]).pipe(
      tap(([router, page, loading, loaded, error]) => {
        if (!loaded && !loading) {
          const slug = router.state.params['slug'] || router.state.data['slug'];
          this.store.dispatch(fromStore.LoadContentPageBySlug({ slug }));
          return;
        }
      }),
      filter(([router, page, loading, loaded]) => loaded),
      map(([router, page, loading, loaded]) => {
        const slug = (router.state.params['slug'] || router.state.data['slug']).toLowerCase();
        if (page.slug !== slug) {
          let url = ['/', 'page', page.slug];

          const newUrl = this.router.createUrlTree(url, {
            relativeTo: this.route,
            queryParams: route.queryParams,
          });

          return newUrl;
        }
        return loaded;
      }),
      take(1)
    );
  }
}
